/**
 * Maoni automatic free gift logic.
 *
 * Keeps exactly one of each configured gift variant in the cart while the
 * value of all non-gift line items reaches the corresponding threshold.
 * Each gift is removed again as soon as its threshold is no longer reached.
 */
(function initMaoniFreeGift() {
  const configElement = document.getElementById('MaoniFreeGiftConfig');
  if (!configElement) return;

  let config;
  try {
    config = JSON.parse(configElement.textContent);
  } catch (error) {
    console.warn('[Maoni Gratisgeschenk] Konfiguration konnte nicht gelesen werden.', error);
    return;
  }

  const configuredGifts = Array.isArray(config.gifts)
    ? config.gifts
    : [config];
  const seenVariantIds = new Set();
  const gifts = configuredGifts.reduce((result, gift) => {
    const variantId = Number(gift.variantId);
    const threshold = Number(gift.threshold);
    if (!variantId || !threshold || seenVariantIds.has(variantId)) return result;

    seenVariantIds.add(variantId);
    result.push({
      variantId,
      threshold,
      available: Boolean(gift.available)
    });
    return result;
  }, []);

  if (gifts.length === 0) return;

  const root = window.Shopify && window.Shopify.routes
    ? window.Shopify.routes.root
    : '/';
  const cartUrl = `${root}cart.js`;
  const addUrl = `${root}cart/add.js`;
  const updateUrl = `${root}cart/update.js`;

  let timer;
  let running = false;
  let runAgain = false;

  const requestJson = async (url, options = {}) => {
    const response = await fetch(url, {
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        ...(options.body ? { 'Content-Type': 'application/json' } : {})
      },
      ...options
    });

    if (!response.ok) {
      const message = await response.text();
      throw new Error(`${response.status}: ${message}`);
    }
    return response.json();
  };

  const refreshCartUi = () => {
    document.dispatchEvent(new CustomEvent('on:cart:change', {
      bubbles: true,
      cancelable: false
    }));
  };

  const reconcile = async () => {
    if (running) {
      runAgain = true;
      return;
    }

    running = true;
    try {
      const cart = await requestJson(cartUrl);
      const giftVariantIds = new Set(gifts.map((gift) => gift.variantId));
      const eligibleValue = cart.items.reduce((sum, item) => {
        if (giftVariantIds.has(Number(item.variant_id))) return sum;
        return sum + Number(item.final_line_price || 0);
      }, 0);
      const updates = {};
      const additions = [];

      gifts.forEach((gift) => {
        const giftLines = cart.items.filter(
          (item) => Number(item.variant_id) === gift.variantId
        );
        const shouldContainGift = gift.available && eligibleValue >= gift.threshold;

        if (shouldContainGift && giftLines.length === 0) {
          additions.push({
            id: gift.variantId,
            quantity: 1,
            properties: {
              _maoni_gratisgeschenk: 'true',
              _maoni_geschenkstufe: String(gift.threshold)
            }
          });
        } else if (shouldContainGift) {
          giftLines.forEach((line, index) => {
            const wantedQuantity = index === 0 ? 1 : 0;
            if (Number(line.quantity) !== wantedQuantity) {
              updates[line.key] = wantedQuantity;
            }
          });
        } else {
          giftLines.forEach((line) => {
            updates[line.key] = 0;
          });
        }
      });

      let cartChanged = false;

      if (Object.keys(updates).length > 0) {
        await requestJson(updateUrl, {
          method: 'POST',
          body: JSON.stringify({ updates })
        });
        cartChanged = true;
      }

      if (additions.length > 0) {
        await requestJson(addUrl, {
          method: 'POST',
          body: JSON.stringify({ items: additions })
        });
        cartChanged = true;
      }

      if (cartChanged) {
        refreshCartUi();
      }
    } catch (error) {
      console.warn('[Maoni Gratisgeschenk] Warenkorb konnte nicht synchronisiert werden.', error);
    } finally {
      running = false;
      if (runAgain) {
        runAgain = false;
        schedule(80);
      }
    }
  };

  const schedule = (delay = 120) => {
    window.clearTimeout(timer);
    timer = window.setTimeout(reconcile, delay);
  };

  document.addEventListener('on:cart:add', () => schedule(40));
  document.addEventListener('on:cart:change', () => schedule(80));
  document.addEventListener('on:cart:after-merge', () => schedule(120));
  document.addEventListener('on:cart-drawer:before-open', () => schedule(0));
  window.addEventListener('pageshow', () => schedule(0));
  schedule(0);
}());
